<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Cartola Proveedor
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta Corriente Proveedor</span>
      <span> /</span>
      <span>Cartola Proveedor</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form autocomplete="off" [formGroup]="formHeader" (ngSubmit)="buscar(true)">
    <div class="card-body justify-content-between">
      <div class="row filtros-body align-items-center">
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <input value="" type="text" class="form-control" placeholder="" required formControlName="rut" formatRut />
            <label for="rutproveedor">RUT Proveedor</label>
            <div *ngIf="
          formHeader.get('rut').invalid &&
          (formHeader.get('rut').dirty ||
          formHeader.get('rut').touched)
        ">
              <mdb-error *ngIf="formHeader.get('rut').hasError('required')">Ingrese Proveedor
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarProveedor()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents;">
            {{ proveedorSeleccionado.nombre }}
          </h6>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required formControlName="fechaDesde">
            </mdb-date-picker>
            <div *ngIf="
                      formHeader.get('fechaDesde').invalid &&
                      (formHeader.get('fechaDesde').dirty ||
                      formHeader.get('fechaDesde').touched)
                    ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required formControlName="fechaHasta">
            </mdb-date-picker>
            <div *ngIf="
                      formHeader.get('fechaHasta').invalid &&
                      (formHeader.get('fechaHasta').dirty ||
                      formHeader.get('fechaHasta').touched)
                    ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </form>
</div>

<div class="card mb-2 wow detalle-cliente" *ngIf="listaRegistros && totales">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaRegistros">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Documento</th>
            <th scope="col">Fecha Pag./Dcto.</th>
            <th scope="col">Vencimiento</th>
            <th scope="col">Ref. Dcto. Nro.</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-right">Cargo</th>
            <th scope="col" class="text-right">Abono</th>
            <th scope="col" class="text-right">Saldo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center" *ngIf="!loading && listaRegistros?.length === 0">No se encontró información</td>
          </tr>
          <tr *ngFor="let registro of listaRegistros">
            <td *ngIf="registro.pago_codigo > 0" (click)="loadAndShowDetallePago(registro)" class="custom_link">{{registro.documento }}</td>
            <td *ngIf="registro.pago_codigo === 0">{{ registro.documento }}</td>
            <td>{{ registro.fecha_registro | fecha }}</td>
            <td>{{ registro.fecha_vencimiento | fecha }}</td>
            <td>{{ registro.referencia_documento }}</td>
            <td align="right">{{ registro.monto | numerico }}</td>
            <td align="right">{{ registro.cargo | numerico }}</td>
            <td align="right">{{ registro.abono | numerico }}</td>
            <td align="right">{{ registro.saldo | numerico }}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)" *ngIf="listaRegistros?.length > 0"></app-pagination>
        <tbody class="blue lighten-5">
          <tr>
            <td align="right" colspan="5"><strong>Saldos finales</strong></td>
            <td align="right">
              <strong>$ {{ totales.cargo | numerico }}</strong>
            </td>
            <td align="right">
              <strong>$ {{ totales.abono | numerico }}</strong>
            </td>
            <td align="right">
              <strong>$ {{ totales.monto | numerico }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaRegistros?.length > 0 && totales">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">Excel</button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect>PDF</button> -->
  </div>
</div>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>

<!-- MODAL verPago-->
<app-consultar-pagos-proveedor-modal-view-details></app-consultar-pagos-proveedor-modal-view-details>
